import { render } from "./kalio-investment-firm-card.vue?vue&type=template&id=5b7dca2d"
import script from "./kalio-investment-firm-card.vue?vue&type=script&lang=js"
export * from "./kalio-investment-firm-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__